import React, { useState } from 'react';

import { TEXTS } from 'application/pages/texts';
import DateUtils from '@zvuk-b2b/react-uikit/toolkit/DateUtils';
import DateInput from '@zvuk-b2b/react-uikit/ui/DateInput';
import Button, { ButtonType } from '@zvuk-b2b/react-uikit/ui/Button';
import ModalScreen from '@zvuk-b2b/react-uikit/ui/ModalScreen';

import styles from './index.module.scss';

export type CustomContentRequestModalProps = {
  title: string;
  initialStartDate: Date;
  initialEndDate: Date;
  minEndDate: Date;
  maxEndDate: Date;
  buttonText: string;
  onSubmit: (startDate: Date, endDate: Date) => void;
  onCancel: () => void;
  withoutDescription?: boolean;
};

const CustomContentRequestModal = ({
  initialStartDate: initialStartDateProp,
  initialEndDate: initialEndDateProp,
  minEndDate,
  maxEndDate,
  title,
  buttonText,
  withoutDescription,
  onSubmit,
  onCancel,
}: CustomContentRequestModalProps) => {
  const [isLoading, setIsloading] = useState(false);
  const initialStartDate = new Date(initialStartDateProp);
  const initialEndDate = new Date(initialEndDateProp);

  const [startDate, setStartDate] = useState<Date | null>(
    initialStartDateProp ? DateUtils.getStartOfDay(initialStartDate) : null
  );

  const [endDate, setEndDate] = useState<Date | null>(
    initialEndDateProp ? DateUtils.getStartOfDay(initialEndDate) : null
  );

  const handleStartDateChange = (value: Date | null) => {
    setStartDate(value);
  };

  const handleEndDateChange = (value: Date | null) => {
    setEndDate(value);
  };

  return (
    <ModalScreen
      title={title}
      disableScroll
      onClose={onCancel}
      containerActionButtonsClassName={styles.ButtonsContainer}
      actionButtons={[
        <Button
          key="button_confirm_custom_content"
          elementId="button_confirm_custom_content"
          isLoading={isLoading}
          type={ButtonType.PRIMARY}
          onClick={async () => {
            setIsloading(true);
            await onSubmit(startDate!, endDate!);
            setIsloading(false);
          }}>
          {buttonText}
        </Button>,
      ]}>
      <div className={styles.CustomContentApplyModalDesc}>
        {!withoutDescription && (
          <span>
            {TEXTS.CUSTOM_CONTENT_REQUEST_MODAL_DESC}
            <span className={styles.CustomContentApplyModalDescBold}>
              {TEXTS.CUSTOM_CONTENT_REQUEST_MODAL_DESC_BOLD}
            </span>
          </span>
        )}
        <span>{TEXTS.CUSTOM_CONTENT_REQUEST_MODAL_SUB_DESC}</span>
      </div>
      <div className={styles.CustomContentApplyModalDates}>
        <DateInput
          elementId="input_start-custom-content"
          placeholder="дд.мм.гггг"
          value={startDate}
          containerClassName={styles.CustomContentApplyModalDate}
          onChange={handleStartDateChange}
          minDate={minEndDate}
          maxDate={maxEndDate}
        />
        <DateInput
          elementId="input_end-custom-content"
          placeholder="дд.мм.гггг"
          value={endDate}
          containerClassName={styles.CustomContentApplyModalDateEnd}
          onChange={handleEndDateChange}
          minDate={minEndDate}
          maxDate={maxEndDate}
        />
      </div>
    </ModalScreen>
  );
};

export default CustomContentRequestModal;
